// MODALS
export const CHANGE_MODAL_STATE = "changeModalState";
// USERSLIST
export const UPDATE_USERS_LIST = "updateUsersList";
export const UPDATE_MY_DATA = "updateMyData";
export const UDPATE_INITIAL_DATA = "updateInitialData";
export const UPDATE_LOADING_STATE = "updateLoadingState";